export default __webpack_public_path__ + "static/media/call_icon.3cf68f26.svg";